export default import.meta.ROLLDOWN_FILE_URL_$fnQ9ZctOvbCEkyq6hpHqA